import { createProvider } from '@nvision/services/data-provider';
import * as api from './api';
import { normalizePalletLoadTypeList } from './normalize';

export const fetchPalletLoadTypeList = createProvider(api.fetchPalletLoadTypeList)
  .useThen((res) => normalizePalletLoadTypeList(res))
  .useCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
  });
